import { Box, Stack, styled as muiStyled } from '@mui/material';

export const DiscountContainer = muiStyled(Stack)(() => ({
  flexDirection: 'row',
  alignItems: 'center',
}));

export const DiscountWrapper = muiStyled(Box)(() => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: '4px',
  cursor: 'pointer',
}));
